<template>
    <div>
        <hua-nav-bar
            :title=" (showAllTab  && !logJumpVisitorList) ? '我的访客' : active === 2 ? '邀约申请' : '审核管理'"
            left-arrow
            @click-left="onClickLeft"
            style="margin-bottom: 10px"
        ></hua-nav-bar>
        <hua-tabs v-model="active" @click="changeTab" v-if="showAllTab  && !logJumpVisitorList">
            <hua-tab :title="item" v-for="(item, index) in tabs" :key="index"></hua-tab>
            <wait-audit
            class="aaaaaaaaabcccc"
                ref="wait"
                v-if="active === 0 || active === 1"
                :v_personid="v_personid"
                :userId="userId"
                :active="active"
                :isVistorList="active === 1 ? true : false"
            ></wait-audit>
            <invite
            class="aaaaaaadeffff"
                :visitorMode="visitorMode"
                ref="inviteRef"
                v-show="active === 2 && inviteMode"
                :v_personid="v_personid"
                :userId="userId"
                :u_name="u_name"
                :u_phone="u_phone"
            ></invite>
            <invite-origin
            class="aaaaaaaavvvvdddd"
                :visitorMode="visitorMode"
                ref="inviteRef"
                v-show="active === 2 && !inviteMode"
                :v_personid="v_personid"
                :userId="userId"
                :u_name="u_name"
                :u_phone="u_phone"
            ></invite-origin>
        </hua-tabs>
        <!-- 只展示待审核和访客列表 -->
        <hua-tabs class="sfdfdsfdfdxc" v-model="active" @click="changeTab" v-else-if="(!showAllTab || logJumpVisitorList) && active !== 2">
            <hua-tab :title="item" v-for="(item, index) in tabs1" :key="index"></hua-tab>
            <wait-audit
                ref="wait"
                v-if="active === 0 || active === 1"
                :v_personid="v_personid"
                :userId="userId"
                :active="active"
                :isVistorList="active === 1 ? true : false"
            ></wait-audit>
        </hua-tabs>
        <!-- 只展示邀约 -->
        <div v-else-if="(!showAllTab || logJumpVisitorList) && active === 2">
            <invite
                :visitorMode="visitorMode"
                ref="inviteRef"
                v-show="active === 2 && inviteMode"
                :v_personid="v_personid"
                :userId="userId"
                :u_name="u_name"
                :u_phone="u_phone"
            ></invite>
            <invite-origin
                :visitorMode="visitorMode"
                ref="inviteRef"
                v-show="active === 2 && !inviteMode"
                :v_personid="v_personid"
                :userId="userId"
                :u_name="u_name"
                :u_phone="u_phone"
            ></invite-origin>
        </div>
    </div>
</template>

<script>
import waitAudit from './components/waitAudit.vue'
import invite from './components/invite.vue'
import inviteOrigin from './components/invite_origin.vue'
import api from '@/constants/api'
export default {
    components: {
        waitAudit,
        invite,
        inviteOrigin
    },
    data() {
        return {
            active: 0,
            u_phone: null,
            u_name: null,
            v_personid: null, //h5
            userId: null, // APP
            tabs: ['待审核', '访客列表', '邀约'],
            tabs1:['待审核', '访客列表'],
            inviteMode:true,
            showAllTab:true,
            // 判断当前页面是不是直接从企业号(logEnterprise)或公众号(log)跳转过来的
            logJumpVisitorList:false,
            jobNum:null,
            visitorMode: '',
        }
    },
    created() {
        this.visitorMode = localStorage.getItem('visitorMode') || ''
    },
    methods: {
        onClickLeft() {
            // console.log( this.showAllTab,"=======showAllTab===========")
            // console.log(localStorage.getItem('logLastPageVisitor'),"============logLastPageVisitor======")
            // console.log(localStorage.getItem('lastPageVisitor'),"============lastPageVisitor======")
            let logLastPageVisitor = localStorage.getItem('logLastPageVisitor')
            let lastPageVisitor = localStorage.getItem('lastPageVisitor')
            let u_phone = JSON.parse(localStorage.getItem("u_phone"))
            let accountCode = ''
            let accountState = ''
            if (localStorage.getItem("accountCode")) {
                accountCode = JSON.parse(localStorage.getItem("accountCode"))
                accountState = JSON.parse(localStorage.getItem("accountState"))
            }
            if (window.navigator.userAgent.indexOf('dhb') !== -1) {
                window.addEventListener('dhbready', async () => {
                    let plugin = await DhbPlugin('dhb/plugin/messagehandle')
                    if (plugin) {
                        plugin.callHandler('finish', 'para', (message) => {
                            console.log(1)
                        })
                    }
                })
            } else if (lastPageVisitor === 'log') {
                // this.$router.push({ path: `/log?phone=${u_phone}` })
                this.$router.push({ path: `/log?code=${accountCode}&state=${accountState}` })
            } else if (lastPageVisitor === 'logEnterprise') {
                this.$router.push({ path: `/${lastPageVisitor}?personCode=${this.jobNum}` })
            }else if (logLastPageVisitor === 'log' && !this.showAllTab) {
                // this.$router.push({ path: `/log?phone=${u_phone}` })
                this.$router.push({ path: `/log?code=${accountCode}&state=${accountState}` })
            }else if (logLastPageVisitor === 'logEnterprise' && !this.showAllTab) {
                this.$router.push({ path: `/${logLastPageVisitor}?personCode=${this.jobNum}` })
            }else {
                this.$router.push({ name: 'index' })
            }
            localStorage.removeItem('v_personid')
        },
        changeTab(name) {
            this.u_name = sessionStorage.getItem('u_name')
            this.u_phone = localStorage.getItem('u_phone')
            if (name === 2) {
                this.$refs.inviteRef.echoUser()
            }
        },
        visitConfig() {
            api.getVisitConfig(130).then((res) => {
                if (res.data[0].value == 0) {
                    this.inviteMode = false
                }else if(res.data[0].value == 1) {
                    this.inviteMode = true
                }
            })
        },
    },
    mounted() {
      // 是否是从访客管理导航再到登录再到访客页面的
      this.showAllTab = !JSON.parse(localStorage.getItem('logJumpLogin'))
      this.logJumpVisitorList = JSON.parse(localStorage.getItem('logJumpVisitorList'))
      this.visitConfig();
      let loginLastPage = localStorage.getItem('loginLastPage');
      if (loginLastPage === 'myVisitorList' || loginLastPage === 'null') {
           this.active = 0;
      } else {
           this.active = Number(localStorage.getItem('myVisitorListActive'));
      }
      this.jobNum = sessionStorage.getItem('u_jobNumber');
      if(this.jobNum) {
        // this.jobNum = typeof this.jobNum === 'string' ? JSON.parse(this.jobNum) : this.jobNum
      }
       //   if(!localStorage.getItem('u_name') || !localStorage.getItem('u_phone')) {
       //     this.$router.push({name: 'index'});
       //   }
        // console.log(localStorage.getItem('v_personid'),"v-personiD============")
        if(!localStorage.getItem('v_personid')) {
           this.$router.push({name: 'index'});
           this.v_personid = localStorage.getItem('v_personid')
        } else {
            this.v_personid = JSON.parse(localStorage.getItem('v_personid')) //h5登录时存的
            this.v_personid = this.v_personid.toString();
        }
        this.userId = localStorage.getItem('userId') //APP登录时存的
        const fromH5 = localStorage.getItem('fromH5');
        if (!fromH5 && this.userId) {
          api.checkPersonIdByuserId(this.userId)
                .then((res) => {
                    this.u_phone = res.data.phone
                    this.u_name = res.data.name
                    this.v_personid = res.data.personId
                    localStorage.setItem('u_phone', JSON.stringify(this.u_phone))
                    sessionStorage.setItem('u_name', this.u_name)
                    localStorage.setItem('v_personid', JSON.stringify(this.v_personid))
                    if (this.$route.params.active) {
                        let active = this.$route.params.active
                        this.active = active === 'detail' ? 1 : active === 2 ? 2 : 0
                    }
                    if (this.active !== 2) {
                        this.$refs.wait.getReviewList(this.v_personid)
                    }
                    this.$router.push({
                        path: `/myVisitorList/${this.v_personid}`,
                    })
                })
                .catch((err) => {
                    localStorage.removeItem('u_phone')
                    sessionStorage.removeItem('u_name')
                    this.$toast(JSON.stringify(err.errMsg));
                })
        } else {
            if (this.$route.params.active) {
                let active = this.$route.params.active
                this.active = active === 'detail' ? 1 : active === 2 ? 2 : 0
            }
            if (this.active !== 2) {
                this.$refs.wait.getReviewList(this.v_personid)
            }
            this.$router.push({
                path: `/myVisitorList/${this.v_personid}`,
            })
        }
    },
     // 判断当前页面是从哪个页面跳转过来的
    beforeRouteEnter (to, from, next) {
        localStorage.setItem('lastPageVisitor', from.name)
        if(from.name === 'log' || from.name === 'logEnterprise') {
            localStorage.setItem('logLastPageVisitor', from.name)
        }
        if(from.name === 'log' || from.name === 'logEnterprise' || from.name ==='approvaSingleLogin') { // 当前是从访客管理导航页面页面跳过来的(公众号(log)或企业号(logEnterprise))
            localStorage.setItem('logJumpVisitorList', JSON.stringify(true))
        }else {
            localStorage.setItem('logJumpVisitorList', JSON.stringify(false))
        }
        next()
    }
}
</script>
